// modules
import { createAction } from 'redux-actions'

// actions
export const setCareGiverShiftReport = createAction(
  'SET_CAREGIVER_SHIFT_REPORT'
)
